import { render, staticRenderFns } from "./Org.vue?vue&type=template&id=6be0ef9d&scoped=true"
import script from "./Org.vue?vue&type=script&lang=js"
export * from "./Org.vue?vue&type=script&lang=js"
import style0 from "./Org.vue?vue&type=style&index=0&id=6be0ef9d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be0ef9d",
  null
  
)

export default component.exports